import React from "react";
import styled from "styled-components";

const StyledHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 80px;
  @media screen and (max-width: 767px) {
    padding: 16px 20px;
  }
`;
const StyledHeaderTitle = styled.h1`
  margin: 0;
`;
const StyledHeaderNav = styled.a`
  display: flex;
  align-items: center;
`;

export const Header: React.FC = () => {
  return (
    <StyledHeader>
      <StyledHeaderTitle>🥺 pien-chekcer</StyledHeaderTitle>
      <StyledHeaderNav
        href="https://qiita.com/kokushin/items/d413464b1d98162d07ad"
        target="_blank"
        rel="noreferrer"
      >
        遊び方
      </StyledHeaderNav>
    </StyledHeader>
  );
};
